import Reveal from "./Reveal.jsx";
import logo from "../data/logo1.png";

const PILLARS = [
  {
    title: "Bespoke Design",
    text: "No templates — every theme, palette and layout is designed around your story.",
    icon: (
      <svg width="30" height="30" viewBox="0 0 30 30">
        <path
          d="M15 3 L18 12 L27 12 L20 18 L23 27 L15 21 L7 27 L10 18 L3 12 L12 12 Z"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.3"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    title: "Flawless Execution",
    text: "A dedicated planner and on-ground crew ensure every minute runs exactly on cue.",
    icon: (
      <svg width="30" height="30" viewBox="0 0 30 30">
        <path
          d="M5 15 L12 22 L25 7"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle
          cx="15"
          cy="15"
          r="12.5"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
        />
      </svg>
    ),
  },
  {
    title: "Timeless Elegance",
    text: "Designs rooted in classic craftsmanship, so your photographs never date.",
    icon: (
      <svg width="30" height="30" viewBox="0 0 30 30">
        <circle
          cx="15"
          cy="15"
          r="12.5"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
        />
        <path
          d="M15 7 V15 L20 19"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
        />
      </svg>
    ),
  },
];

export default function About() {
  return (
    <section className="about" id="about">
      <div className="container about-grid">
        <Reveal className="about-visual">
          <img
            src={logo}
            alt="Zafwa Royale Events"
            loading="lazy"
            // className="brand-logo "
          />
          {/* <svg viewBox="0 0 420 460" className="about-illustration" aria-hidden="true">
            <defs>
              <linearGradient id="goldGrad" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0" stopColor="#F1D28A" />
                <stop offset="1" stopColor="#B4863F" />
              </linearGradient>
            </defs>
            <rect x="10" y="10" width="400" height="440" rx="4" fill="none" stroke="url(#goldGrad)" strokeWidth="1.5" />
            <rect x="24" y="24" width="372" height="412" rx="2" fill="none" stroke="url(#goldGrad)" strokeWidth="0.6" opacity="0.6" />
            <g transform="translate(210,190)">
              <circle r="86" fill="none" stroke="url(#goldGrad)" strokeWidth="1.4" />
              <circle r="70" fill="none" stroke="url(#goldGrad)" strokeWidth="0.6" opacity="0.7" />
              <path d="M0 -108 l9 18 -9 9 -9-9 z" fill="url(#goldGrad)" />
              <path d="M-46 96 C -30 70, -46 46, -70 40 C -52 58, -54 82, -34 104 Z" fill="url(#goldGrad)" opacity="0.9" />
              <path d="M46 96 C 30 70, 46 46, 70 40 C 52 58, 54 82, 34 104 Z" fill="url(#goldGrad)" opacity="0.9" />
              <text y="14" textAnchor="middle" fontFamily="Cormorant Garamond, serif" fontSize="64" fill="url(#goldGrad)" fontWeight="600">
                ZR
              </text>
            </g>
            <text x="210" y="410" textAnchor="middle" fontFamily="Cormorant Garamond, serif" fontStyle="italic" fontSize="17" fill="url(#goldGrad)">
              Est. 2013 — Zafwa Royale Events
            </text>
          </svg> */}
        </Reveal>

        <div className="about-content">
          <Reveal as="p" className="eyebrow">
            Our Story
          </Reveal>
          <Reveal as="h2" className="section-title" delay={60}>
            Crafting Royal Experiences
            <br />
            Since 2013
          </Reveal>
          <Reveal as="p" delay={120}>
            Zafwa Royale Events Management LLC was founded on a simple belief —
            every gathering, big or small, deserves to feel extraordinary. What
            began as a boutique wedding styling studio has grown into a
            full-service event house trusted by families and brands to design
            weddings, galas and celebrations that guests remember for years.
          </Reveal>
          <Reveal as="p" delay={180}>
            We pair meticulous logistics with an artist's eye for detail:
            hand-picked florals, custom lighting design, curated cuisine and a
            production team that treats your event like the main event it truly
            is. From intimate soirées to thousand-guest galas, we bring the same
            devotion to craft to every occasion.
          </Reveal>

          <div className="pillars">
            {PILLARS.map((pillar, i) => (
              <Reveal className="pillar" delay={i * 60} key={pillar.title}>
                <span className="pillar-icon" aria-hidden="true">
                  {pillar.icon}
                </span>
                <h3>{pillar.title}</h3>
                <p>{pillar.text}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
